import { render, staticRenderFns } from "./feesPivot.vue?vue&type=template&id=0aa9ed88&scoped=true"
import script from "./feesPivot.vue?vue&type=script&lang=js"
export * from "./feesPivot.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aa9ed88",
  null
  
)

export default component.exports